import { createContext, useContext, useState } from "react";

import moment from "moment-timezone";

const initialState = {
  breakdowns: ["site"],
  setBreakdowns: () => {},

  tableBreakdowns: [],
  setTableBreakdowns: () => {},

  businessCurr: "usd",
  setBusinessCurr: () => {},

  startDate: moment().subtract(7, "days").format("DD.MM.YYYY"),
  setStartDate: () => {},

  endDate: moment().subtract(0, "days").format("DD.MM.YYYY"),
  setEndDate: () => {},
};

const BusinessBreakdownAndFiltersContext = createContext(initialState);

export function useBusinessBreakdownAndFilters() {
  const context = useContext(BusinessBreakdownAndFiltersContext);

  if (!context) {
    throw new Error(
      "Please use useBusinessBreakdownAndFilters under BusinessBreakdownAndFiltersProvider"
    );
  }

  return context;
}

export default function BusinessBreakdownAndFiltersProvider({ children }) {
  const [breakdowns, setBreakdowns] = useState(initialState.breakdowns);
  const [tableBreakdowns, setTableBreakdowns] = useState(
    initialState.breakdowns
  );
  const [startDate, setStartDate] = useState(initialState.startDate);
  const [endDate, setEndDate] = useState(initialState.endDate);
  const [businessCurr, setBusinessCurr] = useState(initialState.businessCurr);

  const onDateRangeChange = (range) => {
    if (typeof range === "undefined") {
      return;
    }
    const dates = {};
    switch (range) {
      case "LH":
        dates.startDate = moment().format("DD.MM.YYYY");
        dates.endDate = moment().format("DD.MM.YYYY");
        break;
      case "T":
        dates.startDate = moment().format("DD.MM.YYYY");
        dates.endDate = moment().format("DD.MM.YYYY");
        break;
      case "Y":
        dates.startDate = moment().subtract(1, "days").format("DD.MM.YYYY");
        dates.endDate = moment().subtract(1, "days").format("DD.MM.YYYY");
        break;
      case "MTD":
        dates.startDate = moment().startOf("month").format("DD.MM.YYYY");
        dates.endDate = moment().format("DD.MM.YYYY");
        break;
      case "7D":
        dates.startDate = moment().subtract(7, "days").format("DD.MM.YYYY");
        dates.endDate = moment().format("DD.MM.YYYY");
        break;
      case "30D":
        dates.startDate = moment().subtract(30, "day").format("DD.MM.YYYY");
        dates.endDate = moment().format("DD.MM.YYYY");
        break;
      case "LM":
        dates.startDate = moment()
          .subtract(1, "month")
          .startOf("month")
          .format("DD.MM.YYYY");
        dates.endDate = moment()
          .subtract(1, "month")
          .endOf("month")
          .format("DD.MM.YYYY");
        break;
      case "L3M":
        dates.startDate = moment()
          .subtract(3, "month")
          .startOf("month")
          .format("DD.MM.YYYY");
        dates.endDate = moment()
          .subtract(1, "month")
          .endOf("month")
          .format("DD.MM.YYYY");
        break;
      case "L6M":
        dates.startDate = moment()
          .subtract(6, "month")
          .startOf("month")
          .format("DD.MM.YYYY");
        dates.endDate = moment()
          .subtract(1, "month")
          .endOf("month")
          .format("DD.MM.YYYY");
        break;
      default:
        return;
    }
    setStartDate(dates.startDate);
    setEndDate(dates.endDate);
  };

  const reset = () => {
    setBreakdowns(initialState.breakdowns);
    setTableBreakdowns([]);
    setStartDate(moment().subtract(7, "days").format("DD.MM.YYYY"));
    setEndDate(moment().subtract(0, "days").format("DD.MM.YYYY"));
  };

  return (
    <BusinessBreakdownAndFiltersContext.Provider
      value={{
        breakdowns,
        setBreakdowns,
        tableBreakdowns,
        setTableBreakdowns,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        businessCurr,
        setBusinessCurr,
        onDateRangeChange,
        reset,
      }}
    >
      {children}
    </BusinessBreakdownAndFiltersContext.Provider>
  );
}
